<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize"> {{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->
                        
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


            <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">      

                
                 <!-- ******* Cards ******* -->  
                <div class="col-md-8 mb-5">

                    <!-- Card Meta -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMeta" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Meta')"
                                        aria-expanded="false" 
                                        aria-controls="collapseMeta" 
                                        data-toggle="collapse"
                                        data-target="#collapseMeta">Meta
                                        <span id="iconToggleMeta" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMeta" 
                                    class="collapse show" 
                                    aria-labelledby="TabMeta" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Meta title -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_title"
                                                v-text="(row.meta_title.length)">
                                            </div>
                                            <label for="inputText4">Meta title</label>
                                            <input class="form-control"
                                                    id="inputText4"  
                                                    type="text" 
                                                    v-model="row.meta_title">
                                        </div>
                                        <!-- End Meta title -->
                                            
                                        <!-- Meta keywords -->
                                        <div class="form-group">
                                            <div class="pull-right f12"
                                                v-if="row.meta_keywords" 
                                                v-text="(row.meta_keywords.length)">
                                            </div>
                                            <label for="inputText5">Meta keywords</label>
                                            <textarea class="form-control"
                                                    id="inputText5" 
                                                    rows="5"  
                                                    v-model="row.meta_keywords">
                                            </textarea>
                                        </div>
                                        <!-- End Meta keywords -->

                                        <!-- Meta description -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_description" 
                                                v-text="(row.meta_description.length)">
                                            </div>
                                            <label for="inputText6">Meta description</label>
                                            <textarea class="form-control" 
                                                    id="inputText6" 
                                                    rows="5" 
                                                    v-model="row.meta_description">
                                            </textarea>
                                        </div>
                                        <!-- End Meta description -->

                                    </div>

                                    <div class="row">
                                        <div class="col-6 pt-3">
                                            <!-- Site Map Changefreq -->
                                            <div class="form-group">
                                                <label for="inputText444">Site Map Changefreq</label>
                                                <select class="form-control" 
                                                        id="inputText444" 
                                                        v-model="row.sitemap_freq">
                                                    <option value="always">always</option>
                                                    <option value="hourly">hourly</option>
                                                    <option value="daily">daily</option>
                                                    <option value="weekly">weekly</option>
                                                    <option value="monthly" selected>monthly</option>
                                                    <option value="yearly">yearly</option>
                                                    <option value="never">never</option>
                                                </select>
                                            </div>
                                            <!-- Site Map Changefreq -->
                                        </div>

                                        <div class="col-6 pt-3">
                                            <!-- Site Map Priority -->
                                                <div class="form-group">
                                                    <label for="inputText555">Site Map Priority</label>
                                                    <select class="form-control" 
                                                            id="inputText555" 
                                                            v-model="row.sitemap_priority">
                                                        <option value="0.0">0.0</option>
                                                        <option value="0.1">0.1</option>
                                                        <option value="0.2">0.2</option>
                                                        <option value="0.3">0.3</option>
                                                        <option value="0.4">0.4</option>
                                                        <option value="0.5" selected>0.5</option>
                                                        <option value="0.6">0.6</option>
                                                        <option value="0.7">0.7</option>
                                                        <option value="0.8">0.8</option>
                                                        <option value="0.9">0.9</option>
                                                        <option value="1.0">1.0</option>
                                                    </select>
                                                </div>
                                            <!-- End Site Map Priority -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Meta -->

                    <!-- Card Cruise -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabCruise" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Cruise')"
                                        aria-expanded="false" 
                                        aria-controls="collapseCruise" 
                                        data-toggle="collapse"
                                        data-target="#collapseCruise">Cruise
                                        <span id="iconToggleCruise" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseCruise" 
                                    class="collapse" 
                                    aria-labelledby="TabCruise" 
                                    data-parent="#accordion">

                                <div class="col-12 pt-3">
                                    
                                    <!-- Title -->
                                    <div class="form-group">
                                        <label for="inputRow1">Title</label>
                                        <input class="form-control" 
                                                id="inputRow1" 
                                                type="text" 
                                                v-model="row.title">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group">
                                        <label for="inputRow2">Slug</label>
                                        <input class="form-control"
                                                id="inputRow2"  
                                                type="text" 
                                                v-model="row.slug" 
                                                @keydown.space.prevent>
                                    </div>
                                    <!-- End Slug -->

                                    <!-- Short Title -->
                                    <div class="form-group">
                                        <label for="inputRow3">Short title</label>
                                        <input class="form-control" 
                                                id="inputRow3" 
                                                type="text" 
                                                v-model="row.short_title">
                                    </div>
                                    <!-- End Short Title -->

                                    
                                    <div class="col-12 row no-padding ui-ml-unset">
                                        <!-- Popular -->
                                        <div class="col-4 no-lpadding">
                                            <div class="form-group">
                                                <label for="inputText45">Popular</label>
                                                <select class="form-control" 
                                                        id="inputText45" 
                                                        v-model="row.popular">
                                                    <option value="">Select Popular</option>
                                                    <option value="popular">Popular</option>
                                                    <option value="topRated">Top rated</option>
                                                    <option value="bestSeller">Best seller</option>
                                                    <option value="bestDeal">Best deal</option>
                                                    <option value="easterOffer">Easter offer</option>
                                                    <option value="limitedSpaces">Limited Spaces</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!-- End Popular -->
                                        <!-- Start Price -->
                                        <div class="col-4 no-lpadding">
                                            <div class="form-group">
                                                <label for="inputRow4">Start price</label>
                                                <input class="form-control" 
                                                        id="inputRow4" 
                                                        type="number"
                                                        min="0"
                                                        v-model.number="row.start_price">
                                            </div>
                                        </div>
                                        <!-- End Start Price -->

                                        <!-- Start have_discount -->
                                        <div class="col-4 no-rpadding">
                                            <div class="form-group">
                                                <label>Have Discount</label>
                                                <div class="custom-control custom-checkbox">
                                                    <input id="exampleCheck5" class="custom-control-input" type="checkbox" :checked="row.have_discount" @click="haveDiscount">
                                                    <label class="custom-control-label" for="exampleCheck5">have discount</label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End have_discount -->

                                        <!-- Discount -->
                                        <div class="col-4 no-lpadding">
                                            <div class="form-group">
                                                <label for="inputText26">Discount (%)</label>
                                                <input class="form-control" 
                                                        id="inputText26" 
                                                        type="number"
                                                        min="0" 
                                                        v-model.number="row.discount">
                                            </div>
                                        </div>
                                        <!-- End Discount -->

                                        <!-- Sort -->
                                        <div class="col-4 no-rpadding">
                                            <div class="form-group">
                                                <label for="inputRow5">Sort</label>
                                                <input class="form-control" 
                                                        id="inputRow5" 
                                                        type="number" 
                                                        min="0" 
                                                        v-model.number="row.sort">
                                            </div>
                                        </div>
                                        <!-- End Sort -->
                                    </div>

                                    <div class="row">
                                        <!-- Stars -->
                                        <div class="col-4">
                                            <div class="form-group">
                                                <label for="inputText66">Stars</label>
                                                <input class="form-control" 
                                                        id="inputText66" 
                                                        type="number"
                                                        min="0" 
                                                        v-model.number="row.stars">
                                            </div>
                                        </div>
                                        <!-- End Stars -->

                                        <!-- Stars No. -->
                                        <div class="col-4">
                                            <div class="form-group">
                                                <label for="inputText77">Stars No.</label>
                                                <input class="form-control" 
                                                        id="inputText77" 
                                                        type="number"
                                                        min="0" 
                                                        v-model.number="row.stars_no">
                                            </div>
                                        </div>
                                        <!-- End Stars No. -->

                                        <!-- Free Photo Session -->
                                        <div class="col-4 no-lpadding">
                                            <div class="form-group">
                                                <label>Free Photo Session</label>
                                                <div class="custom-control custom-checkbox">
                                                    <input id="exampleCheck55" class="custom-control-input" type="checkbox" :checked="row.free_photo_session" @click="haveFreePhotoSession">
                                                    <label class="custom-control-label" for="exampleCheck55">free photo session</label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Free Photo Session -->
                                    </div>

                                    <div class="row">
                                        <!-- Sort Duration -->
                                        <div class="col-4">
                                            <div class="form-group">
                                                <label for="inputText88">Sort Duration</label>
                                                <input class="form-control" 
                                                        id="inputText88" 
                                                        type="number"
                                                        min="0" 
                                                        v-model.number="row.sort_duration">
                                            </div>
                                        </div>
                                        <!-- End Sort Duration -->

                                        <!-- Duration -->
                                        <div class="col-8">
                                            <div class="form-group">
                                                <label for="inputText10">Duration</label>
                                                <input class="form-control" 
                                                        id="inputText10" 
                                                        type="text" 
                                                        v-model="row.duration">
                                            </div>
                                        </div>
                                        <!-- End Duration -->
                                    </div>

                                    <!-- Location -->
                                    <div class="form-group">
                                        <label for="inputTextLocation">Location</label>
                                        <input class="form-control"
                                                id="inputTextLocation"
                                                type="text"
                                                v-model="row.location">
                                    </div>
                                    <!-- End Location -->

                                    <!-- Run Dates -->
                                    <div class="form-group">
                                        <label for="inputEditor78">Run Dates</label>
                                        <input class="form-control" 
                                                id="inputText78" 
                                                type="text" 
                                                v-model="row.run_dates">
                                    </div>
                                    <!-- End Run Dates -->

                                    <div class="row">
                                      <!-- Guide Language -->
                                      <div class="col-6">
                                        <div class="form-group">
                                            <label for="inputEditor88">Guide Language</label>
                                            <input class="form-control"
                                                    id="inputText88"
                                                    type="text"
                                                    v-model="row.guide_lang">
                                        </div>
                                      </div>
                                      <!-- End Guide Language -->

                                      <!-- Rating Type -->
                                        <div class="col-6">
                                          <div class="form-group">
                                            <label for="inputEditor88">Rating Type</label>
                                            <input class="form-control"
                                                   id="inputText88"
                                                   type="text"
                                                   v-model="row.rating_type">
                                          </div>
                                        </div>
                                        <!-- End Rating Type -->
                                    </div>

                                    <!-- Visited Location -->
                                    <div class="form-group">
                                        <label for="inputEditor1">Visited Location</label>
                                        <editor
                                            id="inputEditor1"
                                            v-model="row.visited_locations"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Visited Location -->
                                    
                                    <!-- Inclusion -->
                                    <div class="form-group">
                                        <label for="iEditor1">Inclusion</label>
                                        <editor
                                            id="iEditor1"
                                            v-model="row.inclusion"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Inclusion -->

                                    <!-- Exclusion -->
                                    <div class="form-group">
                                        <label for="iEditor2">Exclusion</label>
                                        <editor
                                            id="iEditor2"
                                            v-model="row.exclusion"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Exclusion -->


                                    <!-- Facilitues -->
                                    <div class="form-group">
                                        <label for="ieditor3">Cruise Facilities</label>
                                        <editor
                                            id="ieditor3"
                                            v-model="row.cruise_facilities"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Facilities -->

                                    <!-- Suite Facilities -->
                                    <div class="form-group">
                                        <label for="iEditor4">Guest Suite Facilities</label>
                                        <editor
                                            id="iEditor4"
                                            v-model="row.guest_suite_facilities"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Suite Facilities -->

                                    <!-- Cabin Facilities -->
                                    <div class="form-group">
                                        <label for="iEditor5">Cabin Facilities</label>
                                        <editor
                                            id="iEditor5"
                                            v-model="row.cabin_facilities"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Cabin Facilities -->

                                    <!-- Cancellation Policies -->
                                    <div class="form-group">
                                        <label for="iEditor6">Cancellation Policies</label>
                                        <editor
                                            id="iEditor6"
                                            v-model="row.cancellation_policies"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Cancellation Policies -->

                                    <!-- Price Note -->
                                    <div class="form-group">
                                        <label for="inputEditor68">Price Note</label>
                                        <editor
                                            id="inputEditor68"
                                            v-model="row.price_note"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Price Note -->


                                    <!-- Body -->
                                    <div class="form-group">
                                        <label for="iEditor7">Short body</label>
                                        <editor
                                            id="iEditor7"
                                            v-model="row.short_body"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group">
                                        <label for="iEditor8">body</label>
                                        <editor
                                            id="iEditor8"
                                            v-model="row.body"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 600,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                external_plugins: editor.external_plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Cruise -->

                    <!-- Card Cruise Highlights -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabCruiseHighlights" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('CruiseHighlights')"
                                        aria-expanded="false"
                                        aria-controls="collapseCruiseHighlights"
                                        data-toggle="collapse"
                                        data-target="#collapseCruiseHighlights">Cruise Highlights
                                        <span id="iconToggleCruiseHighlights"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseCruiseHighlights"
                                    class="collapse show"
                                    aria-labelledby="TabCruiseHighlights"
                                    data-parent="#accordion">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <editor
                                                id="inputEditorCruiseHighlights"
                                                v-model="row.cruise_highlights"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Cruise Highlights -->

                    <!-- Card Dining Info -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabDiningInfo" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('DiningInfo')"
                                        aria-expanded="false"
                                        aria-controls="collapseDiningInfo"
                                        data-toggle="collapse"
                                        data-target="#collapseDiningInfo">Dining Info
                                        <span id="iconToggleDiningInfo"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseDiningInfo"
                                    class="collapse show"
                                    aria-labelledby="TabDiningInfo"
                                    data-parent="#accordion">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <editor
                                                id="inputEditorDiningInfo"
                                                v-model="row.dining_info"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Dining Info -->

                    <!-- Card Amenities -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabAmenities" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Amenities')"
                                        aria-expanded="false"
                                        aria-controls="collapseAmenities"
                                        data-toggle="collapse"
                                        data-target="#collapseAmenities">Amenities
                                        <span id="iconToggleAmenities"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseAmenities"
                                    class="collapse"
                                    aria-labelledby="TabAmenities"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(amenity, aIdx) in row.amenities"
                                             :key="'amenity_'+aIdx"
                                             class="ui-for-div mb-4">

                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeAmenity(aIdx)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>

                                            <div class="form-group">
                                                <label>Amenity Title</label>
                                                <input class="form-control"
                                                       type="text"
                                                       v-model="amenity.title">
                                            </div>

                                            <div class="form-group">
                                                <label>Description</label>
                                                <editor
                                                    v-model="amenity.description"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 200,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="col-6">
                                                    <div class="form-group">
                                                        <label>Icon</label>
                                                        <p>
                                                            <img v-if="amenity.icon_preview"
                                                                :src="amenity.icon_preview"
                                                                class="custom-image">
                                                        </p>
                                                        <input class="form-control"
                                                                type="file"
                                                                accept="image/*"
                                                                v-on:change="onAmenityIconChange($event, aIdx)">
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Icon class</label>
                                                        <input class="form-control"
                                                               type="text"
                                                               placeholder="e.g. fas fa-wifi"
                                                               v-model="amenity.icon_class">
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="form-group">
                                                        <label>Popular</label>
                                                        <div class="custom-control custom-checkbox">
                                                            <input :id="'cruiseAmenityPopular'+aIdx"
                                                                   class="custom-control-input"
                                                                   type="checkbox"
                                                                   v-model="amenity.popular">
                                                            <label class="custom-control-label"
                                                                   :for="'cruiseAmenityPopular'+aIdx">popular</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr/>
                                        </div>

                                        <div class="row pull-right">
                                            <button type="button"
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="addAmenity()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Amenities -->

                    <!-- Card Cruise Policies -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabPolicies" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Policies')"
                                        aria-expanded="false"
                                        aria-controls="collapsePolicies"
                                        data-toggle="collapse"
                                        data-target="#collapsePolicies">Cruise Policies
                                        <span id="iconTogglePolicies"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapsePolicies"
                                    class="collapse"
                                    aria-labelledby="TabPolicies"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(policy, pIdx) in row.policies"
                                             :key="'policy_'+pIdx"
                                             class="ui-for-div mb-4">

                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removePolicy(pIdx)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>

                                            <div class="form-group">
                                                <label>Policy Title</label>
                                                <input class="form-control"
                                                       type="text"
                                                       v-model="policy.title">
                                            </div>

                                            <div class="form-group">
                                                <label>Description</label>
                                                <editor
                                                    v-model="policy.description"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 200,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="col-6 form-group">
                                                    <label>Icon</label>
                                                    <p>
                                                        <img v-if="policy.icon_preview"
                                                            :src="policy.icon_preview"
                                                            class="custom-image">
                                                    </p>
                                                    <input class="form-control"
                                                            type="file"
                                                            accept="image/*"
                                                            v-on:change="onPolicyIconChange($event, pIdx)">
                                                </div>
                                                <div class="col-6 form-group">
                                                    <label>Icon class</label>
                                                    <input class="form-control"
                                                           type="text"
                                                           placeholder="e.g. fas fa-wifi"
                                                           v-model="policy.icon_class">
                                                </div>
                                            </div>

                                            <hr/>
                                        </div>

                                        <div class="row pull-right">
                                            <button type="button"
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="addPolicy()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Cruise Policies -->

                    <!-- Card Ship Specifications -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabShipSpecifications" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('ShipSpecifications')"
                                        aria-expanded="false"
                                        aria-controls="collapseShipSpecifications"
                                        data-toggle="collapse"
                                        data-target="#collapseShipSpecifications">Ship Specifications
                                        <span id="iconToggleShipSpecifications"
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseShipSpecifications"
                                    class="collapse"
                                    aria-labelledby="TabShipSpecifications"
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <div v-for="(spec, sIdx) in row.shipSpecifications"
                                             :key="'spec_'+sIdx"
                                             class="ui-for-div mb-4">

                                            <div class="pull-right ui-mt-10">
                                                <button type="button"
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeShipSpecification(sIdx)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                </button>
                                            </div>

                                            <div class="form-group">
                                                <label>Specification Title</label>
                                                <input class="form-control"
                                                       type="text"
                                                       v-model="spec.title">
                                            </div>

                                            <div class="form-group">
                                                <label>Description</label>
                                                <editor
                                                    v-model="spec.description"
                                                    :api-key="editor.api_key"
                                                    :init="{
                                                        height: 200,
                                                        menubar: editor.menubar,
                                                        plugins: editor.plugins,
                                                        external_plugins: editor.external_plugins,
                                                        toolbar: editor.toolbar
                                                    }"
                                                />
                                            </div>

                                            <div class="row col-12 ui-ml-unset">
                                                <div class="col-6 form-group">
                                                    <label>Icon</label>
                                                    <p>
                                                        <img v-if="spec.icon_preview"
                                                            :src="spec.icon_preview"
                                                            class="custom-image">
                                                    </p>
                                                    <input class="form-control"
                                                            type="file"
                                                            accept="image/*"
                                                            v-on:change="onShipSpecificationIconChange($event, sIdx)">
                                                </div>
                                                <div class="col-6 form-group">
                                                    <label>Icon class</label>
                                                    <input class="form-control"
                                                           type="text"
                                                           placeholder="e.g. fas fa-wifi"
                                                           v-model="spec.icon_class">
                                                </div>
                                            </div>

                                            <hr/>
                                        </div>

                                        <div class="row pull-right">
                                            <button type="button"
                                                class="btn btn-dark btn-circle btn-with-icon"
                                                @click="addShipSpecification()">
                                                <span class="btn-icon ti-plus font-bold"></span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Ship Specifications -->

                    <!-- Card Price -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabPrices" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Prices')"
                                        aria-expanded="false" 
                                        aria-controls="collapsePrices" 
                                        data-toggle="collapse"
                                        data-target="#collapsePrices">Prices
                                        <span id="iconTogglePrices" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapsePrices" 
                                    class="collapse" 
                                    aria-labelledby="TabPrices" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.price_key" 
                                                :key="i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Price Name -->
                                                <div class="form-group">
                                                    <label :for="'pInput'+i">Price Name</label>
                                                    <input class="form-control" 
                                                            :id="'pInput'+i" 
                                                            type="text" 
                                                            v-model="row.price_names[i]">
                                                </div>
                                                <!-- End Price Name -->

                                                
                                                <!-- Price Items -->
                                                <div v-for="x in 10" 
                                                    :key="x" 
                                                    :class="(x != 0) ? 'hidden' : ''"
                                                    :id="'sub_'+i+'_'+x">

                                                    <div class="row col-12 ui-ml-unset">
                                                        <div class="form-group col-1"></div>
                                                        <div class="form-group col-5">
                                                            <label :for="'pvInput'+i+'_'+x">Price Value</label>
                                                            <input class="form-control" 
                                                                    :id="'pvInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.price_item_value[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-5">
                                                            <label :for="'pcInput'+i+'_'+x">Content</label>
                                                            <input class="form-control" 
                                                                    :id="'pcInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.price_item_body[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-1">
                                                            <button type="button" 
                                                                v-if="x != 0"
                                                                @click="removeSubOption(i,x)"
                                                                class="btn btn-circle btn-with-icon ui-mt30">
                                                                <span class="btn-icon ti-close font-bold"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Price Items -->

                                                <!-- Price add more -->
                                                <div class="form-group col-1">
                                                    <button type="button" 
                                                        @click="opnSub(i)"
                                                        class="btn btn-secondary btn-circle btn-with-icon ui-mt30 ui-ml-20">
                                                        <span class="btn-icon ti-plus font-bold"></span>
                                                    </button>
                                                </div>
                                                <!-- End Price add more -->
                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Price -->

                    <!-- Card Itineraries -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabItineraries" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Itineraries')"
                                        aria-expanded="false" 
                                        aria-controls="collapseItineraries" 
                                        data-toggle="collapse"
                                        data-target="#collapseItineraries">Itineraries
                                        <span id="iconToggleItineraries" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseItineraries" 
                                    class="collapse" 
                                    aria-labelledby="TabItineraries" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.itinerarie_key" 
                                                :key="i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm2_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption2(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Itinerarie Name -->
                                                <div class="form-group">
                                                    <label :for="'iInput'+i">Itinerarie Name</label>
                                                    <input class="form-control" 
                                                            :id="'iInput'+i" 
                                                            type="text" 
                                                            v-model="row.itinerarie_names[i]">
                                                </div>
                                                <!-- End Itinerarie Name -->


                                                
                                                <!-- Itinerarie Items -->
                                                <div v-for="x in 20" 
                                                    :key="x" 
                                                    :class="(x != 0) ? 'hidden' : ''"
                                                    :id="'itisub_'+i+'_'+x">

                                                    <div class="row col-12 ui-ml-unset">
                                                        <div class="form-group col-12">
                                                            <label :for="'itiNInput'+i+'_'+x">Day Name</label>
                                                            <input class="form-control" 
                                                                    :id="'itiNInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.itinerarie_item_name[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label :for="'itiCInput'+i+'_'+x">Body</label>
                                                            <editor
                                                                :id="'itiCInput'+i+'_'+x" 
                                                                v-model="row.itinerarie_item_body[i+'_'+x]"
                                                                :api-key="editor.api_key"
                                                                :init="{
                                                                    height: 300,
                                                                    menubar: editor.menubar,
                                                                    plugins: editor.plugins,
                                                                    external_plugins: editor.external_plugins,
                                                                    toolbar: editor.toolbar
                                                                }"
                                                            />
                                                        </div>
                                                        <div class="form-group col-6">
                                                            <label :for="'itiNInput'+i+'_'+x">Meals</label>
                                                            <input class="form-control" 
                                                                    :id="'itiNInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.itinerarie_item_meals[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-6">
                                                            <label :for="'itiNInput'+i+'_'+x">Accomodation</label>
                                                            <input class="form-control" 
                                                                    :id="'itiNInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.itinerarie_item_accomodation[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-1">
                                                            <button type="button" 
                                                                v-if="x != 0"
                                                                @click="removeItiSubOption(i,x)"
                                                                class="btn btn-circle btn-with-icon ui-mt30">
                                                                <span class="btn-icon ti-close font-bold"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Itinerarie Items -->
                                                <!-- Itinerarie add more -->
                                                <div class="form-group col-1">
                                                    <button type="button" 
                                                        @click="opnItiSub(i)"
                                                        class="btn btn-secondary btn-circle btn-with-icon ui-mt30 ui-ml-20">
                                                        <span class="btn-icon ti-plus font-bold"></span>
                                                    </button>
                                                </div>
                                                <!-- End Itinerarie add more -->

                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm2()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Itineraries -->

                    <!-- Card Galeries -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabGalleries" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Galleries')"
                                        aria-expanded="false" 
                                        aria-controls="collapseGalleries" 
                                        data-toggle="collapse"
                                        data-target="#collapseGalleries">Galleries
                                        <span id="iconToggleGalleries" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                    </div>
                                    <div id="collapseGalleries" 
                                        class="collapse" 
                                        aria-labelledby="TabIGalleries" 
                                        data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- For Loop -->
                                        <div v-for="i in row.gallery_key" 
                                            :key="'i3'+i" 
                                            :class="(i == 0) ? 'hidden' : ''"
                                            :id="'frm3_'+i"
                                            class="ui-for-div">

                                             <!--  Remove -->
                                            <div class="pull-right ui-mt-10">
                                                <button v-if="i != 0"
                                                    type="button" 
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeOption3(i)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                 </button>
                                            </div>
                                            <!-- End Remove -->

                                            <!-- Itineraries Title -->
                                            <div class="form-group">
                                                <label :for="'gImageText'+i">Image</label>
                                               <p>
                                                    <img v-if="(row.gallery_image_preview[i])" 
                                                        :src="row.gallery_image_preview[i]" 
                                                        class="custom-image">
                                                </p>
                                                <input class="form-control" 
                                                        :id="'gImageText'+i" 
                                                        type="file"
                                                        v-on:change="onGalleryImageChange($event, i)">
                                            </div>
                                            <!-- End Itineraries Title -->

                                            <div class="col-12 row no-padding ui-ml-unset">
                                                <div class="col-6 no-lpadding">
                                                    <div class="form-group">
                                                        <label :for="'gAltText'+i">Image Alt</label>
                                                        <input class="form-control" 
                                                                :id="'gAltText'+i" 
                                                                type="text"
                                                                v-model="row.gallery_image_alt[i]">
                                                    </div>
                                                </div>

                                                <div class="col-6 no-rpadding">
                                                    <div class="form-group">
                                                        <label :for="'gTitleText'+i">Image Title</label>
                                                        <input class="form-control" 
                                                                :id="'gTitleText'+i"
                                                                type="text"
                                                                v-model="row.gallery_image_title[i]">
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- End loop -->

                                        </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm3()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Galleries -->




                    <!-- Card Trip Information -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabTripInformation" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('TripInformation')"
                                        aria-expanded="false" 
                                        aria-controls="collapseTripInformation" 
                                        data-toggle="collapse"
                                        data-target="#collapseTripInformation">Trip Information
                                        <span id="iconToggleTripInformation" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseTripInformation" 
                                    class="collapse" 
                                    aria-labelledby="TabTripInformation" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.trip_information_key" 
                                                :key="'i2'+i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm4_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption4(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Trip Information Name -->
                                                <div class="form-group">
                                                    <label :for="'tInput'+i">Title</label>
                                                    <input class="form-control" 
                                                            :id="'tInput'+i" 
                                                            type="text" 
                                                            v-model="row.trip_information_names[i]">
                                                </div>
                                                <!-- End Trip Information Name -->

                                                <!-- Trip Information Order -->
                                                <div class="form-group">
                                                    <label :for="'tOrder'+i">Order</label>
                                                    <input class="form-control" 
                                                            :id="'tOrder'+i" 
                                                            min="0"
                                                            type="number" 
                                                            v-model="row.trip_information_orders[i]">
                                                </div>
                                                <!-- End Trip Information Order -->

                                                <!-- Trip Information Body -->
                                                <div class="form-group">
                                                    <label :for="'tEditor'+i">Body</label>
                                                    <editor
                                                        :id="'tEditor'+i"
                                                        v-model="row.trip_information_body[i]"
                                                        :api-key="editor.api_key"
                                                        :init="{
                                                            height: 300,
                                                            menubar: editor.menubar,
                                                            plugins: editor.plugins,
                                                            external_plugins: editor.external_plugins,
                                                            toolbar: editor.toolbar
                                                        }"
                                                    />
                                                </div>
                                                <!-- End Trip Information Body -->
                                                
                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm4()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Trip Information -->


                </div>
                <!-- ******* End Cards ******* -->


                <!-- ******* SideNav ******** -->
                <div class="col-md-4 mb-5">

                    <!-- Nav Language -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavLanguage" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Language')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavLanguage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavLanguage">Language
                                        <span id="iconToggleLanguage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavLanguage" 
                                    class="collapse" 
                                    aria-labelledby="NavLanguage" 
                                    data-parent="#accordionNav">
                                
                                <div class="col-12 pt-3">
                                    <!-- Language -->
                                    <div class="form-group">
                                        <div v-if="languageLoading" class="text-center">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                role="status" 
                                                aria-hidden="true">
                                            </span>
                                        </div>
                                        <select class="form-control custom-select"
                                                v-if="!languageLoading" 
                                                v-model="row.language_id">
                                                <option value="">Select Language</option>
                                                <option v-for="(language, index) in languages" 
                                                        :key="index"
                                                        :value="language.id">
                                                        {{ language.name }}
                                                </option>
                                        </select>
                                    </div>
                                    <!-- End Language -->
                                </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Language -->

                    <!-- Nav Category -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavCategory" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Category')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavCategory" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavCategory">Category
                                        <span id="iconToggleCategory" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavCategory" 
                                    class="collapse" 
                                    aria-labelledby="NavCategory" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="categoryLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                v-if="!categoryLoading" 
                                                v-model="row.category_id">
                                                <option value="">Select Category</option>
                                                <option v-for="(category, index) in categories" 
                                                        :key="index"
                                                        :value="category.id">
                                                        {{ category.title }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Category -->

                    <!-- Nav Cruise Type -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavType" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Type')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavType" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavType">Cruise Type
                                            <span id="iconToggleType" 
                                                    class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavType" 
                                        class="collapse" 
                                        aria-labelledby="NavType" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Type -->
                                            <div class="form-group">
                                                <div v-if="typeLoading" class="text-center">
                                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                                        role="status" 
                                                        aria-hidden="true">
                                                    </span>
                                                </div>
                                                <select class="form-control custom-select"
                                                    v-if="!typeLoading" 
                                                    v-model="row.cruise_type_id">
                                                    <option value="">Select Cruise Type</option>
                                                    <option v-for="(type, index) in types" 
                                                            :key="index"
                                                            :value="type.id">
                                                            {{ type.title }}
                                                    </option>
                                                </select>
                                            </div>
                                            <!-- End Type -->
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- End Nav Cruise Type -->


                    <!-- Nav Cruise Cabins -->
                    <div class="card mt-5">
                        <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavCabins" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Cabins')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavCabins" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavCabins">Multiple Cruise Cabins
                                            <span id="iconToggleCabins" 
                                                    class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavCabins" 
                                        class="collapse" 
                                        aria-labelledby="NavCabins" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Cabins -->
                                            <div class="form-group">
                                                <div v-if="cabinLoading" class="text-center">
                                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                                        role="status" 
                                                        aria-hidden="true">
                                                    </span>
                                                </div>
                                                <multiselect v-if="!cabinLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.cabinsValues" 
                                                    :options="cabinsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search cabins"
                                                    :preselect-first="false">
                                                </multiselect>
                                            </div>
                                            <!-- End Cabins -->
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- End Nav Crusie Cabins -->

                    <!-- Nav Multiple Icons -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleIcons" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleIcons')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleIcons" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleIcons">Multiple Icons
                                        <span id="iconToggleMultipleIcons" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleIcons" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleIcons" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="iconsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!iconsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.iconsValues" 
                                                    :options="iconsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search icons"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Icons -->

                    <!-- Nav Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('Image')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavImage">Featued Image
                                            <span id="iconToggleImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavImage" 
                                        class="collapse" 
                                        aria-labelledby="NavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img :src="row.image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onImageChange"
                                                    accept="image/*">
                                            </div>
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                            </div>
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_title">
                                            </div>
                                            <!-- Image -->
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- End Nav Image -->

                    <!-- Nav Mobile Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="MobileNavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MobileImage')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseMobileNavImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseMobileNavImage">Mobile Featured Image
                                        <span id="iconToggleMobileImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMobileNavImage" 
                                    class="collapse" 
                                    aria-labelledby="MobileNavImage" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                            <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img v-if="row.mobile_image_preview"
                                                :src="row.mobile_image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onMobileImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- Image -->

                                        <!-- Image Alt -->
                                        <div class="form-group">
                                            <label>Image alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.mobile_image_alt">
                                        </div>
                                        <!-- End Image Alt -->

                                        <!-- Image Title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.mobile_image_title">
                                        </div>
                                        <!-- End Image Title -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Mobile Image -->

                    <!-- Nav Short Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavShortImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('ShortImage')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseNavShortImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavShortImage">Short Image
                                            <span id="iconToggleShortImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavShortImage" 
                                        class="collapse" 
                                        aria-labelledby="NavShortImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img :src="row.short_image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onShortImageChange"
                                                    accept="image/*">
                                            </div>
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.short_image_alt">
                                            </div>
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.short_image_title">
                                            </div>
                                            <!-- Image -->
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- End Nav Short Image -->

                    <!-- Linked FAQs -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavFaqs" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Faqs')"
                                        aria-expanded="false" 
                                        aria-controls="collapseNavFaqs" 
                                        data-toggle="collapse"
                                        data-target="#collapseNavFaqs">Linked FAQs
                                        <span id="iconToggleFaqs" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavFaqs" 
                                    class="collapse" 
                                    aria-labelledby="NavFaqs" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <p class="text-muted small">Order follows selection order in the list.</p>
                                        <div class="form-group">
                                            <div v-if="faqsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!faqsLoading"
                                                id="multiselect-faqs-cruises"
                                                v-model="row.faqsValues" 
                                                :options="faqsOptions" 
                                                :multiple="true"
                                                :close-on-select="false" 
                                                :clear-on-select="false" 
                                                :hide-selected="true" 
                                                :preserve-search="true" 
                                                :taggable="false"
                                                label="title"
                                                track-by="id"
                                                placeholder="Search and select FAQs"
                                                :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Linked FAQs -->

                    <!-- Nav Status -->
                    <div class="card mt-5">
                        <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavStatus" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Status')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavStatus" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavStatus">Status & Visibility
                                            <span id="iconToggleStatus" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Status -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch1" 
                                                        :checked="row.status"
                                                        @click="onStatus">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch1"
                                                        v-html="(row.status) ? 'Active' : 'Inactive'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End Status -->

                                            <!-- View In Home -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch2" 
                                                        :checked="row.view_in_home"
                                                        @click="onHome">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch2"
                                                        v-html="(row.view_in_home) 
                                                            ? 'View In Home' : 'Hide In Home'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View In Home -->

                                            <!-- View in menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch5" 
                                                        :checked="row.view_in_menu"
                                                        @click="onViewInMenu">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch5"
                                                        v-html="(row.view_in_menu) 
                                                            ? 'Show In Menu' 
                                                            : 'Hide In Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in menu -->

                                            <!-- Menu Order -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: orderDisplay}"
                                                            placeholder="Order In Menu" 
                                                            id="inputText8" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.menu_order">
                                                </div>
                                            </div>
                                            <!-- End Menu Order -->

                                            <!-- View in sub menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch6" 
                                                        :checked="row.view_in_sub_menu"
                                                        @click="onViewInSubMenu">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch6"
                                                        v-html="(row.view_in_sub_menu) 
                                                            ? 'Show In Sub Menu' 
                                                            : 'Hide In Sub Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in sub menu -->
                                            <!--  Menu -->
                                            <div class="col-12 pt-3">
                                                <div class="form-group">
                                                    <div v-if="menuLoading" class="text-center">
                                                        <span class="spinner-grow spinner-grow-sm mr-1" 
                                                            role="status" 
                                                            aria-hidden="true">
                                                        </span>
                                                    </div>
                                                    <select v-bind:style="{display: inputDisplay}" class="form-control custom-select"
                                                        v-if="!menuLoading" 
                                                        v-model="row.menu_id">
                                                        <option value="">Select Menu</option>
                                                        <option v-for="(menu, index) in menus" 
                                                                :key="index"
                                                                
                                                                :value="menu.id">
                                                                {{ menu.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!--  End Menu -->

                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- End Nav Status -->

                </div>
                <!-- ******* End SideNav ******** -->


                </div>
            </div>
            <!-- End Content -->


                <div class="col-md-12 row">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" 
                                    aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading"> Create Cruise</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>


            </form>
        </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Multiselect from 'vue-multiselect';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Editor,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // meta
                    meta_title: '',
                    meta_keywords: '',
                    meta_description: '',

                    //sitemap
                    sitemap_freq: 'monthly',
                    sitemap_priority: 0.5,

                    // row
                    title: '',
                    slug: '',
                    short_title: '',
                    start_price: '',
                    have_discount: 0,
                    discount: '',
                    stars: '',
                    stars_no: '',
                    run_dates: '',
                    guide_lang: '',
                    rating_type: '',
                    price_note: '',
                    sort: 0,
                    duration: '',
                    sort_duration: 0,
                    visited_locations: '',
                    inclusion: '',
                    exclusion: '',
                    cruise_facilities: '',
                    guest_suite_facilities: '',
                    cabin_facilities: '',
                    cancellation_policies: '',
                    location: '',
                    cruise_highlights: '',
                    dining_info: '',
                    short_body: '',
                    body: '',
                    free_photo_session: 0,
                    popular: '',

                    // amenities / policies / ship specifications
                    amenities: [],
                    policies: [],
                    shipSpecifications: [],

                    // prices
                    price_key: 0,
                    prices: [],
                    price_names: [],
                    // items
                    price_items: [],
                    price_item_key: [],
                    price_item_value: [],
                    price_item_body: [],

                    // itineraries
                    itinerarie_key: 0,
                    itineraries: [],
                    
                    itinerarie_names: [],
                    // items
                    itinerarie_items: [],
                    itinerarie_item_key: [],
                    itinerarie_item_name: [],
                    itinerarie_item_body: [],
                    itinerarie_item_meals: [],
                    itinerarie_item_accomodation: [],

                    // galleries
                    galleries: [],
                    gallery_key: 0,
                    gallery_image_preview: [],
                    gallery_image_base64: [],
                    gallery_image_alt: [],
                    gallery_image_title: [],

                    // trip information
                    trip_information_key: 0,
                    tripInformations: [],
                    trip_information_names: [],
                    trip_information_orders: [],
                    trip_information_body: [],

                    // navbar
                    cruise_type_id: '',
                    cabinsValues: [],

                    // category
                    category_id: '',

                    // multiple icons
                    iconsValues: [],
                    
                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // mobile image
                    mobile_image_preview: '',
                    mobile_image_base64: '',
                    mobile_image_alt: '',
                    mobile_image_title: '',

                    // short image
                    short_image_preview: '',
                    short_image_base64: '',
                    short_image_alt: '',
                    short_image_title: '',
                    
                    // status & visibility
                    status: 1,
                    view_in_home: 0,
                    view_in_menu: 0,
                    view_in_sub_menu: 0,
                    menu_id: '',
                    menu_order: '',

                    //language
                    language_id:'',
                    faqsValues: [],
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },
                // cruise types
                types: [],
                typeLoading: true,

                // category
                categories: [],
                categoryLoading: true,

                // cabins
                cabinsOptions: [],
                cabinLoading: true,

                // multiple icons
                iconsOptions: [],
                iconsLoading: true,

                pgLoading: false,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'cruises',

                
                // language
                languages: [],
                languageLoading: true,

                // menu
                menus: [],
                menuLoading: true,
                inputDisplay: 'none',
                orderDisplay: 'none',

                faqsOptions: [],
                faqsLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchLanguages();
            this.fetchFaqs();

        },
        methods: {

            fetchFaqs(){
                this.faqsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/faqs',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 1000,
                    },
                };
                this.axios(options)
                    .then(res => {
                        this.faqsOptions = res.data.rows || [];
                    })
                    .catch(() => { this.faqsOptions = []; })
                    .finally(() => { this.faqsLoading = false; });
            },

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                        this.fetchCategories(); // call next func
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetchCategories
            fetchCategories() {
                this.categoryLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/categories',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        is_cruise: 1,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.categoryLoading = false;
                    this.categories = res.data.rows;
                    
                    this.fetchCruiseTypes(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },
            
            // Fetch Regions
            fetchCruiseTypes(){
                this.regionLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/cruisetypes',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.typeLoading = false;
                        this.types = res.data.rows;

                        this.fetchCruiseCabins(); // call next func
                    })
                    .catch(() => {})
                    .finally(() => {});
            },


            fetchCruiseCabins() {
                this.cabinLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/cabins',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.cabinLoading = false;
                        this.cabinsOptions = res.data.cabins;

                        this.fetchMultipleIcons(); // call next function
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetchMultipleIcons
            fetchMultipleIcons(){
                this.iconsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/icons',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.iconsLoading = false;
                    this.iconsOptions = res.data.icons;
                    //
                })
                .catch(() => {})
                .finally(() => {});
            },



            // Amenities
            addAmenity() {
                this.row.amenities.push({
                    title: '', description: '', popular: false, sort: this.row.amenities.length,
                    icon_preview: '', icon_base64: '', icon_alt: '', icon_title: '', icon_class: '',
                });
            },
            removeAmenity(idx) {
                this.row.amenities.splice(idx, 1);
            },
            onAmenityIconChange(e, idx) {
                const file = e.target.files[0];
                const amenity = this.row.amenities[idx];
                amenity.icon_preview = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ev => {
                    amenity.icon_base64 = ev.target.result;
                };
            },
            serializeAmenities(amenities) {
                return (amenities || []).map((amenity, index) => ({
                    ...amenity,
                    sort: amenity && amenity.sort != null ? amenity.sort : index,
                    popular: amenity.popular ? 1 : 0,
                }));
            },

            // Cruise Policies
            addPolicy() {
                this.row.policies.push({
                    title: '', description: '', sort: this.row.policies.length,
                    icon_preview: '', icon_base64: '', icon_alt: '', icon_title: '', icon_class: '',
                });
            },
            removePolicy(idx) {
                this.row.policies.splice(idx, 1);
            },
            onPolicyIconChange(e, idx) {
                const file = e.target.files[0];
                const policy = this.row.policies[idx];
                policy.icon_preview = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ev => {
                    policy.icon_base64 = ev.target.result;
                };
            },
            serializePolicies(policies) {
                return (policies || []).map((policy, index) => ({
                    ...policy,
                    sort: policy && policy.sort != null ? policy.sort : index,
                }));
            },

            // Ship Specifications
            addShipSpecification() {
                this.row.shipSpecifications.push({
                    title: '', description: '', sort: this.row.shipSpecifications.length,
                    icon_preview: '', icon_base64: '', icon_alt: '', icon_title: '', icon_class: '',
                });
            },
            removeShipSpecification(idx) {
                this.row.shipSpecifications.splice(idx, 1);
            },
            onShipSpecificationIconChange(e, idx) {
                const file = e.target.files[0];
                const spec = this.row.shipSpecifications[idx];
                spec.icon_preview = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ev => {
                    spec.icon_base64 = ev.target.result;
                };
            },
            serializeShipSpecifications(specs) {
                return (specs || []).map((spec, index) => ({
                    ...spec,
                    sort: spec && spec.sort != null ? spec.sort : index,
                }));
            },

            // Add New
            addNew(){
                if(this.tenant_id == 0) {

                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {

                    if (this.row.status == false) {
                        this.row.status = 0;
                    } else {
                        this.row.status = 1;
                    }
                    if (this.row.view_in_home == false) {
                        this.row.view_in_home = 0;
                    } else {
                        this.row.view_in_home = 1;
                    }

                    if (this.row.view_in_menu == false) {
                        this.row.view_in_menu = 0;
                    } else {
                        this.row.view_in_menu = 1;
                    }

                    if (this.row.view_in_sub_menu == false) {
                        this.row.view_in_sub_menu = 0;
                    } else {
                        this.row.view_in_sub_menu = 1;
                    }
                    
                    if(this.row.have_discount == false) {
                        this.row.have_discount = 0;
                    } else {
                        this.row.have_discount = 1;
                    }

                    if(this.row.free_photo_session == false) {
                        this.row.free_photo_session = 0;
                    } else {
                        this.row.free_photo_session = 1;
                    }
                    
                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };

                    // prices
                    for( let i = 1; i < this.row.price_names.length; i++ ) {
                            for( let x = 1; x <= 10; x++) {
                            let item_value = this.row.price_item_value[i+'_'+x];
                            let item_body  = this.row.price_item_body[i+'_'+x];
                            if(item_value) {
                                this.row.price_items[x] = {
                                    'item_value' : item_value,
                                    'item_body'  : item_body
                                }
                            }
                        }
                        this.row.prices[i] = {
                            'price_name' : this.row.price_names[i],
                            'items'      : this.row.price_items
                        }
                        this.row.price_items = []; // clear array
                    }

                    // itineraries
                    for( let i = 1; i < this.row.itinerarie_names.length; i++ ) {

                        for( let x = 1; x <= 20; x++) {
                            let item_name = this.row.itinerarie_item_name[i+'_'+x];
                            let item_body  = this.row.itinerarie_item_body[i+'_'+x];
                            let item_meals = this.row.itinerarie_item_meals[i+'_'+x];
                            let item_accomodation = this.row.itinerarie_item_accomodation[i+'_'+x];
                            if(item_name) {
                                this.row.itinerarie_items[x] = {
                                    'item_name' : item_name,
                                    'item_body' : item_body,
                                    'item_meals'   : item_meals,
                                    'item_accomodation'  : item_accomodation,
                                }
                            }
                        }
                        this.row.itineraries[i] = {
                            'itinerarie_name'   : this.row.itinerarie_names[i],
                            'itinerarie_items'  : this.row.itinerarie_items
                        }
                        this.row.itinerarie_items = []; // clear array
                    }

                    // trip informations
                    for( let i = 1; i < this.row.trip_information_names.length; i++ ) {
                        if (this.row.trip_information_names[i] != "") {
                            this.row.tripInformations[i] = {
                                'title'  : this.row.trip_information_names[i],
                                'order' : this.row.trip_information_orders[i],
                                'body'  : this.row.trip_information_body[i]
                            }
                        }
                    }

                    // galleries
                    for( let i = 1; i < this.row.gallery_image_base64.length; i++ ) {
                        this.row.galleries[i] = {
                            'gallery_image_base64' : this.row.gallery_image_base64[i],
                            'gallery_image_alt' : this.row.gallery_image_alt[i],
                            'gallery_image_title' : this.row.gallery_image_title[i]
                        }
                    }

                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs,
                        method: 'POST',
                        data: {
                            tenant_id: this.tenant_id,
                            // meta
                            meta_title: this.row.meta_title,
                            meta_keywords: this.row.meta_keywords,
                            meta_description: this.row.meta_description,

                            //sitemap
                            sitemap_freq: this.row.sitemap_freq,
                            sitemap_priority: this.row.sitemap_priority,

                            // row
                            title: this.row.title,
                            slug: this.row.slug,
                            short_title: this.row.short_title,
                            start_price: this.row.start_price,
                            have_discount: this.row.have_discount,
                            discount: this.row.discount,
                            stars: this.row.stars,
                            stars_no: this.row.stars_no,
                            run_dates: this.row.run_dates,
                            guide_lang: this.row.guide_lang,
                            rating_type: this.row.rating_type,
                            price_note: this.row.price_note,
                            sort: this.row.sort,      
                            duration: this.row.duration,
                            sort_duration: this.row.sort_duration,
                            visited_locations: this.row.visited_locations,                  
                            inclusion: this.row.inclusion,
                            exclusion: this.row.exclusion,
                            cruise_facilities: this.row.cruise_facilities,
                            guest_suite_facilities: this.row.guest_suite_facilities,
                            cabin_facilities: this.row.cabin_facilities,
                            cancellation_policies: this.row.cancellation_policies,
                            location: this.row.location,
                            cruise_highlights: this.row.cruise_highlights,
                            dining_info: this.row.dining_info,
                            short_body: this.row.short_body,
                            body: this.row.body,
                            free_photo_session: this.row.free_photo_session,
                            popular: this.row.popular,

                            // amenities / policies / ship specifications
                            amenities: this.serializeAmenities(this.row.amenities),
                            policies: this.serializePolicies(this.row.policies),
                            ship_specifications: this.serializeShipSpecifications(this.row.shipSpecifications),

                            // price
                            prices: this.row.prices,

                            // itineraries
                            itineraries: this.row.itineraries,

                            // galleries
                            galleries: this.row.galleries,

                            // trip information
                            TripInformation: this.row.tripInformations,

                            // navbar
                            cruise_type_id: this.row.cruise_type_id,
                            cabins: this.row.cabinsValues,
                            category_id: this.row.category_id,
                            icons: this.row.iconsValues,

                            // images
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // mobile image 
                            mobile_image_base64: this.row.mobile_image_base64,
                            mobile_image_alt: this.row.mobile_image_alt,
                            mobile_image_title: this.row.mobile_image_title,

                            short_image_base64: this.row.short_image_base64,
                            short_image_alt: this.row.short_image_alt,
                            short_image_title: this.row.short_image_title,

                            // status & visibility
                            status: this.row.status,
                            view_in_home: this.row.view_in_home,
                            view_in_menu: this.row.view_in_menu,
                            menu_order: this.row.menu_order,
                            view_in_sub_menu: this.row.view_in_sub_menu,
                            menu_id: this.row.menu_id,
                            
                            //language
                            language_id: this.row.language_id,
                            faqs: (this.row.faqsValues || []).map(f => f.id),
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Added Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: err.response.data.message
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            haveDiscount() {
                if(this.row.have_discount)
                    this.row.have_discount = 0;
                else
                    this.row.have_discount = 1;
            },

            haveFreePhotoSession() {
                if(this.row.free_photo_session)
                    this.row.free_photo_session = 0;
                else
                    this.row.free_photo_session = 1;
            },
            
            // items add more
            opnFrm() {
                this.row.price_key++;
                this.row.price_item_key[this.row.price_key] = 0;
            },
            removeOption(i) {
                document.querySelector('#frm_'+i).remove();
                this.row.price_names[i] = '';
                this.row.price_item_key[i] = '';
                // this.row.price_key--; // makes issue

                // clear all sub
                let n = [1,2,3,4,5,6,7,8,9,10];
                n.forEach(x => {
                    this.row.price_item_value[i+'_'+x] = '';
                    this.row.price_item_body[i+'_'+x] = '';
                });
            },
            opnSub(i) {
                this.row.price_item_key[i] += 1;
                document.querySelector('#sub_'+i+'_'+this.row.price_item_key[i]).classList.remove('hidden');
            },
            opnItiSub(i) {
                this.row.itinerarie_item_key[i] += 1;
                document.querySelector('#itisub_'+i+'_'+this.row.itinerarie_item_key[i]).classList.remove('hidden');
            },
            removeSubOption(i,x) {
                document.querySelector('#sub_'+i+'_'+x).classList.add('hidden');
                this.row.price_item_value[i+'_'+x] = '';
                this.row.price_item_body[i+'_'+x] = '';
                this.row.price_item_key[i] -= 1;
            },

            removeItiSubOption(i,x) {
                document.querySelector('#itisub_'+i+'_'+x).classList.add('hidden');
                this.row.itinerarie_item_name[i+'_'+x] = '';
                this.row.itinerarie_item_body[i+'_'+x] = '';
                this.row.itinerarie_item_meals[i+'_'+x] = '';
                this.row.itinerarie_item_accomodation[i+'_'+x] = '';
                this.row.itinerarie_item_key[i] -= 1;
            },

            // itineraries add more
            opnFrm2() {
                this.row.itinerarie_key++;
                this.row.itinerarie_item_key[this.row.itinerarie_key] = 0;
            },
            removeOption2(i) {
                document.querySelector('#frm2_'+i).remove();

                this.row.itinerarie_names[i] = '';
                this.row.itinerarie_item_key[i] = '';
                // clear all sub
                let n = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];
                n.forEach(x => {
                    this.row.itinerarie_item_name[i+'_'+x] = '';
                    this.row.itinerarie_item_body[i+'_'+x] = '';
                    this.row.itinerarie_item_meals[i+'_'+x] = '';
                    this.row.itinerarie_item_accomodation[i+'_'+x] = '';
                });

            },

            // items3 add more
            opnFrm3() {
                this.row.gallery_key++;
            },
            removeOption3(i) {
                document.querySelector('#frm3_'+i).remove();
                this.row.gallery_image_preview[i] = '';
                this.row.gallery_image_base64[i] = '';
                this.row.gallery_image_alt[i] = '';
                this.row.gallery_image_title[i] = '';
            },
            
            removeOption4(i) {
                document.querySelector('#frm4_'+i).remove();
                this.row.trip_information_names[i] = '';
                this.row.trip_information_orders[i] = '';
                this.row.trip_information_body[i] = '';
            },
            
            opnFrm4() {
                this.row.trip_information_key++;
            },

            // Title
            onTitleChange() {
                this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str=''){
                if(!str) {
                    str = this.row.slug;
                }
                this.row.slug = str.replace(/\s+/g, '-');
            },

            // Upload images
            onGalleryImageChange(e, i){
                const file = e.target.files[0];
                this.row.gallery_image_preview[i] = URL.createObjectURL(file);
                this.createBase64Gallery(file, i);
            },
            createBase64Gallery(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.gallery_image_base64[i] = e.target.result;
                };
            },

            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },
            // Upload Mobile Featured image
            onMobileImageChange(e){
                const file = e.target.files[0];
                this.row.mobile_image_preview = URL.createObjectURL(file);
                this.createBase64MobileImage(file);
            },
            createBase64MobileImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.mobile_image_base64 = e.target.result;
                };
            },
            onShortImageChange(e){
                const file = e.target.files[0];
                this.row.short_image_preview = URL.createObjectURL(file);
                this.createBase64ShortImage(file)
            },
            createBase64ShortImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.short_image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },
            onHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            },

            // view in menu
            onViewInMenu(){
                if(this.row.view_in_menu) {
                    this.row.view_in_menu = 0;
                    this.orderDisplay = 'none';
                }
                else {
                    this.row.view_in_menu = 1;
                    this.orderDisplay = 'block';
                }
            },

            // view in sub menu
            onViewInSubMenu(){
                if(this.row.view_in_sub_menu) {
                    this.row.view_in_sub_menu = 0;
                    this.inputDisplay = 'none';
                }
                else {
                    this.row.view_in_sub_menu = 1;
                    this.inputDisplay = 'block';
                }
            },

            // fetchMenus
            fetchMenus() {
                this.menuLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/menus',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.menuLoading = false;
                    this.menus = res.data.rows;                    
                })
                .catch(() => {})
                .finally(() => {});
            },
            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                if (div == 'Status') {
                    this.fetchMenus();
                }
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
